var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* tslint:disable */
/* eslint:disable */
/**
* @typedef {string} Url
*/
/**
* @typedef {string} GUID
*/
/**
* @typedef {number} DateTime
*/
var dummy;
var defaultConfig = { endpoint: 'forums-users' };
var init = function (webOrMobileLogger) { return function (userConfig) {
    if (userConfig === void 0) { userConfig = {}; }
    var defaults = userConfig.defaults, restOfConfig = __rest(userConfig, ["defaults"]);
    var config = __assign(__assign({}, defaultConfig), restOfConfig);
    var factoryInstance = typeof webOrMobileLogger.factory === 'function' ? webOrMobileLogger.factory(config) : webOrMobileLogger;
    var logger = getLogger(factoryInstance);
    return defaults ? logger.util.updateDefaults(defaults) : logger;
}; };
export var initCustomLogger = function (factoryInstance) { return getLogger(factoryInstance); };
var getLogger = function (biLoggerClientFactoryInstance) {
    return new Logger(biLoggerClientFactoryInstance);
};
var Logger = /** @class */ (function () {
    function Logger(biLoggerClientFactoryInstance) {
        var _this = this;
        this.biLoggerClientFactoryInstance = biLoggerClientFactoryInstance;
        this.util = {
            updateDefaults: function (defaults) {
                _this.biLoggerClientFactoryInstance.updateDefaults(defaults);
                return _this;
            },
            log: function (logParams, context) {
                return _this.bi.log(logParams, context);
            }
        };
        biLoggerClientFactoryInstance
            .updateDefaults({ src: 69 });
        this.bi = biLoggerClientFactoryInstance.logger({ endpoint: 'forums-users' });
    }
    ;
    /**
    * @typedef {Object} forumSettingsShowHeaderParams
    * @property {string} editor_view_mode - mobile / desktop
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} option - on/off (default - on)
    * @property {string} origin - ADI / Editor
    * @property {GUID} site_member_id - member id
    * @property {string} type - category_list / post_list
    * @property {GUID} uuid - uuid
    **/
    /**
     * Name: Forum settings: show header. Evid: 42.
     * Event description: When the user clicks on toggle in layout-> show header.
    
     * editor_view_mode - Type: string. Desc: mobile / desktop
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * option - Type: string. Desc: on/off (default - on)
     *
     * origin - Type: string. Desc: ADI / Editor
     *
     * site_member_id - Type: guid. Desc: member id
     *
     * type - Type: string. Desc: category_list / post_list
     *
     * uuid - Type: guid. Desc: uuid
     * @param {forumSettingsShowHeaderParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.forumSettingsShowHeader = function (params) {
        return this.bi.log(__assign({ evid: 42 }, params));
    };
    /**
    * @typedef {Object} bmBulkActionPostsDeleteParams
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - msid
    * @property {string} origin - business_manager
    * @property {number} page_count - total page count
    * @property {number} page_nr - current page nr
    * @property {number} posts_count - selected posts count
    * @property {string} posts_format - discussion / question / all
    * @property {GUID} site_member_id - site member id
    **/
    /**
     * Name: BM - Delete posts (bulk action). Evid: 601.
     * Event description: Event triggered when deleting multiple posts in BM.
    
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: business_manager
     *
     * page_count - Type: numeric. Desc: total page count
     *
     * page_nr - Type: numeric. Desc: current page nr
     *
     * posts_count - Type: numeric. Desc: selected posts count
     *
     * posts_format - Type: string. Desc: discussion / question / all
     *
     * site_member_id - Type: guid. Desc: site member id
     * @param {bmBulkActionPostsDeleteParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bmBulkActionPostsDelete = function (params) {
        return this.bi.log(__assign({ evid: 601 }, params));
    };
    /**
    * @typedef {Object} forumSettingsFileSizeLimitParams
    * @property {GUID} app_id - null
    * @property {GUID} instance_id - instance id
    * @property {number} limit_value - limit in bytes
    * @property {string} member_Id - member id
    * @property {GUID} biToken - msid
    * @property {string} origin - editor
    * @property {GUID} site_member_id - site_member_id
    * @property {GUID} uuid - null
    **/
    /**
     * Name: Forum settings: file size limit. Evid: 69.
     * Event description: Event triggered when feature is turned On/Off or new value of upload file size limit is saved in settings.
    
     * app_id - Type: guid.
     *
     * instance_id - Type: guid. Desc: instance id
     *
     * limit_value - Type: numeric. Desc: limit in bytes
     *
     * member_Id - Type: string. Desc: member id
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: editor
     *
     * site_member_id - Type: guid. Desc: site_member_id
     *
     * uuid - Type: guid.
     * @param {forumSettingsFileSizeLimitParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.forumSettingsFileSizeLimit = function (params) {
        return this.bi.log(__assign({ evid: 69 }, params));
    };
    /**
    * @typedef {Object} businessManagerForumSettingsParams
    * @property {string} action - Save, Go to posts, Cancel
    * @property {GUID} app_id - guid
    * @property {string} banned_words - written banned_words
    * @property {number} file_size_limit - limit in bytes, if toggle is off - then null
    * @property {GUID} instance_id - instance id
    * @property {boolean} is_edited - 1, 0
    * @property {GUID} biToken - msid
    * @property {number} post_limit - null, 1, 5, 10
    * @property {GUID} site_member_id - site_member_id
    * @property {string} spam_words - written spam words
    * @property {GUID} uuid - uuid
    **/
    /**
     * Name: Business Manager Forum settings. Evid: 81.
     * Event description: Event triggered when user press "Save", "Cancel" or "Go to posts".
    
     * action - Type: string. Desc: Save, Go to posts, Cancel
     *
     * app_id - Type: guid. Desc: guid
     *
     * banned_words - Type: string. Desc: written banned_words
     *
     * file_size_limit - Type: numeric. Desc: limit in bytes, if toggle is off - then null
     *
     * instance_id - Type: guid. Desc: instance id
     *
     * is_edited - Type: bool. Desc: 1, 0
     *
     * biToken - Type: guid. Desc: msid
     *
     * post_limit - Type: numeric. Desc: null, 1, 5, 10
     *
     * site_member_id - Type: guid. Desc: site_member_id
     *
     * spam_words - Type: string. Desc: written spam words
     *
     * uuid - Type: guid. Desc: uuid
     * @param {businessManagerForumSettingsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.businessManagerForumSettings = function (params) {
        return this.bi.log(__assign({ evid: 81 }, params));
    };
    /**
    * @typedef {Object} clickOnLinkParams
    * @property {string} comment_id - comment id (if exists)
    * @property {GUID} instance_id - null
    * @property {string} link - url
    * @property {GUID} biToken - null
    * @property {string} origin - post/comment/reply
    * @property {string} post_id - post id
    * @property {GUID} site_member_id - site_member_id
    **/
    /**
     * Name: Click on link in OneApp. Evid: 16.
     * Event description: When the user clicks on a link in a post/comment/reply.
    
     * comment_id - Type: string. Desc: comment id (if exists)
     *
     * instance_id - Type: guid.
     *
     * link - Type: string. Desc: url
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: post/comment/reply
     *
     * post_id - Type: string. Desc: post id
     *
     * site_member_id - Type: guid. Desc: site_member_id
     * @param {clickOnLinkParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickOnLink = function (params) {
        return this.bi.log(__assign({ evid: 16 }, params));
    };
    /**
    * @typedef {Object} forumSettingsChangeMainPageTypeParams
    * @property {GUID} instance_id - forum instance guid
    * @property {GUID} biToken - metasite guid
    * @property {string} option - list_of_categories / list_of_posts
    * @property {string} origin - ADI / Editor
    * @property {GUID} site_member_id - site_member_id
    * @property {GUID} uuid - owner uuid
    **/
    /**
     * Name: Forum settings: change main page type. Evid: 71.
     * Event description: When a user chooses type of main page in "Display main page as" section..
    
     * instance_id - Type: guid. Desc: forum instance guid
     *
     * biToken - Type: guid. Desc: metasite guid
     *
     * option - Type: string. Desc: list_of_categories / list_of_posts
     *
     * origin - Type: string. Desc: ADI / Editor
     *
     * site_member_id - Type: guid. Desc: site_member_id
     *
     * uuid - Type: guid. Desc: owner uuid
     * @param {forumSettingsChangeMainPageTypeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.forumSettingsChangeMainPageType = function (params) {
        return this.bi.log(__assign({ evid: 71 }, params));
    };
    /**
    * @typedef {Object} postDeletedParams
    * @property {string} category_posts_format - discussion / question / all
    * @property {GUID} instance_id - null
    * @property {boolean} is_admin - 0 - not the admin / 1 - the admin
    * @property {GUID} biToken - null
    * @property {string} origin - live / business_manager
    * @property {string} post_id - post_id guid
    * @property {GUID} site_member_id - site_member_id
    * @property {string} type - post, comment
    **/
    /**
     * Name: post deleted. Evid: 555.
     * Event description: Event triggered after post is deleted.
    
     * category_posts_format - Type: string. Desc: discussion / question / all
     *
     * instance_id - Type: guid.
     *
     * is_admin - Type: bool. Desc: 0 - not the admin / 1 - the admin
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: live / business_manager
     *
     * post_id - Type: string. Desc: post_id guid
     *
     * site_member_id - Type: guid. Desc: site_member_id
     *
     * type - Type: string. Desc: post, comment
     * @param {postDeletedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.postDeleted = function (params) {
        return this.bi.log(__assign({ evid: 555 }, params));
    };
    /**
    * @typedef {Object} postLoadedParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} post_id - post id
    **/
    /**
     * Name: Post loaded. Evid: 26.
     * Event description: When a post is loaded.
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * post_id - Type: string. Desc: post id
     * @param {postLoadedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.postLoaded = function (params) {
        return this.bi.log(__assign({ evid: 26 }, params));
    };
    /**
    * @typedef {Object} postPublishedParams
    * @property {boolean} category_changed - 0 - didnt change category / 1 - did change category
    * @property {number} file_count - Number of files attached to a post
    * @property {boolean} has_emoji - 0 - no emoji / 1 - with emoji
    * @property {boolean} has_gallery - 0 - no gallery, 1 - with gallery
    * @property {boolean} has_gif - 0 - no gif / 1 - has gif
    * @property {boolean} has_hashtag - 0 - no hashtag / 1 - has hashtag
    * @property {boolean} has_image - 0 - no image / 1 - with image
    * @property {boolean} has_mention - 0 - no mention / 1 - with mention
    * @property {boolean} has_quote - 0 - no quote / 1 - with quote
    * @property {boolean} has_video - 0 - no video/ 1 - with video
    * @property {number} hashtag_count - the number of hashtags in post
    * @property {number} image_count - the number of images in the post
    * @property {number} image_in_gallery_count - the number of images in gallery
    * @property {string} initiated_by - comment_bar, NULL
    * @property {GUID} instance_id - null
    * @property {boolean} is_admin - 0 - not the admin / 1 - the admin
    * @property {boolean} is_bot - checks UA to identify bot
    * @property {boolean} is_custom_video - 0 - no custom video / 1 - has video uploaded through video upload
    * @property {boolean} is_edited - 0 - new post / 1 - edit (to know if its posted for first time)
    * @property {string} media_source - "file"(when uploading file in web) / "gallery"(when uploading file from oneApp ) / "camera" (for oneApp)  / "link" (adding video using link in Web)
    * @property {number} mention_count - the number of mentions in post
    * @property {GUID} biToken - null
    * @property {string} origin - live / business_manager
    * @property {string} parent_post_id - parent post/question guid for comment, reply. Null if initial post.
    * @property {string} post_id - post/comment/reply guid
    * @property {string} posts_format - discussion / question
    * @property {GUID} site_member_id - site_member_id
    * @property {string} type - post, comment,  reply, general
    **/
    /**
     * Name: post published. Evid: 523.
     * Event description: Event triggered after post is published.
    
     * category_changed - Type: bool. Desc: 0 - didnt change category / 1 - did change category
     *
     * file_count - Type: numeric. Desc: Number of files attached to a post
     *
     * has_emoji - Type: bool. Desc: 0 - no emoji / 1 - with emoji
     *
     * has_gallery - Type: bool. Desc: 0 - no gallery, 1 - with gallery
     *
     * has_gif - Type: bool. Desc: 0 - no gif / 1 - has gif
     *
     * has_hashtag - Type: bool. Desc: 0 - no hashtag / 1 - has hashtag
     *
     * has_image - Type: bool. Desc: 0 - no image / 1 - with image
     *
     * has_mention - Type: bool. Desc: 0 - no mention / 1 - with mention
     *
     * has_quote - Type: bool. Desc: 0 - no quote / 1 - with quote
     *
     * has_video - Type: bool. Desc: 0 - no video/ 1 - with video
     *
     * hashtag_count - Type: numeric. Desc: the number of hashtags in post
     *
     * image_count - Type: numeric. Desc: the number of images in the post
     *
     * image_in_gallery_count - Type: numeric. Desc: the number of images in gallery
     *
     * initiated_by - Type: string. Desc: comment_bar, NULL
     *
     * instance_id - Type: guid.
     *
     * is_admin - Type: bool. Desc: 0 - not the admin / 1 - the admin
     *
     * is_bot - Type: bool. Desc: checks UA to identify bot
     *
     * is_custom_video - Type: bool. Desc: 0 - no custom video / 1 - has video uploaded through video upload
     *
     * is_edited - Type: bool. Desc: 0 - new post / 1 - edit (to know if its posted for first time)
     *
     * media_source - Type: string. Desc: "file"(when uploading file in web) / "gallery"(when uploading file from oneApp ) / "camera" (for oneApp)  / "link" (adding video using link in Web)
     *
     * mention_count - Type: numeric. Desc: the number of mentions in post
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: live / business_manager
     *
     * parent_post_id - Type: string. Desc: parent post/question guid for comment, reply. Null if initial post.
     *
     * post_id - Type: string. Desc: post/comment/reply guid
     *
     * posts_format - Type: string. Desc: discussion / question
     *
     * site_member_id - Type: guid. Desc: site_member_id
     *
     * type - Type: string. Desc: post, comment,  reply, general
     * @param {postPublishedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.postPublished = function (params) {
        return this.bi.log(__assign({ evid: 523 }, params));
    };
    /**
    * @typedef {Object} categoriesOpenAccessModalWindowParams
    * @property {string} access_type - members / roles / badges / paid_plans
    * @property {string} category_id - category id guid
    * @property {GUID} instance_id - forum instance id
    * @property {GUID} biToken - msid
    * @property {GUID} site_member_id - site member id
    * @property {GUID} uuid - uuid
    **/
    /**
     * Name: Categories - open access modal window. Evid: 585.
     * Event description: Event triggered when user open access modal window to edit Roles/Badges/Paid Plans.
    
     * access_type - Type: string. Desc: members / roles / badges / paid_plans
     *
     * category_id - Type: string. Desc: category id guid
     *
     * instance_id - Type: guid. Desc: forum instance id
     *
     * biToken - Type: guid. Desc: msid
     *
     * site_member_id - Type: guid. Desc: site member id
     *
     * uuid - Type: guid. Desc: uuid
     * @param {categoriesOpenAccessModalWindowParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.categoriesOpenAccessModalWindow = function (params) {
        return this.bi.log(__assign({ evid: 585 }, params));
    };
    /**
    * @typedef {Object} editorSettingsTabOpenedParams
    * @property {string} app_id - app_id
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - msid
    * @property {string} origin - For Web: App settings
    * @property {string} tab_name - tab name inside post settings: "Main", "Layout", "Display", "Design", "Support", "Add-Ons"
    **/
    /**
     * Name: Editor settings tab opened. Evid: 86.
     * Event description: Tab inside editor settings opened.
    
     * app_id - Type: string. Desc: app_id
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: For Web: App settings
     *
     * tab_name - Type: string. Desc: tab name inside post settings: "Main", "Layout", "Display", "Design", "Support", "Add-Ons"
     * @param {editorSettingsTabOpenedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.editorSettingsTabOpened = function (params) {
        return this.bi.log(__assign({ evid: 86 }, params));
    };
    /**
    * @typedef {Object} followAllCategoriesWixAppParams
    * @property {GUID} app_id - app_id
    * @property {GUID} instance_id - null
    * @property {GUID} msid - msid
    * @property {GUID} biToken - null
    * @property {GUID} site_member_id - site_member_id
    * @property {string} type - 'follow' /'unfollow'
    * @property {GUID} uuid - uuid
    **/
    /**
     * Name: Follow all categories Wix App. Evid: 61.
     * Event description: Event triggered when in "All Categories" pressing 'Follow'/'Unfollow' makes you follow/unfollow all categories.
    
     * app_id - Type: guid. Desc: app_id
     *
     * instance_id - Type: guid.
     *
     * msid - Type: guid. Desc: msid
     *
     * biToken - Type: guid.
     *
     * site_member_id - Type: guid. Desc: site_member_id
     *
     * type - Type: string. Desc: 'follow' /'unfollow'
     *
     * uuid - Type: guid. Desc: uuid
     * @param {followAllCategoriesWixAppParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.followAllCategoriesWixApp = function (params) {
        return this.bi.log(__assign({ evid: 61 }, params));
    };
    /**
    * @typedef {Object} forumAddPanelForumElementAddedParams
    * @property {string} element_type - recent post /
    * @property {GUID} instance_id - null
    * @property {string} layout - vertical/vertical_with_stats/horizontal/horizontal_with_stats
    * @property {GUID} msid - msid
    * @property {GUID} biToken - null
    **/
    /**
     * Name: Forum add panel - forum element added. Evid: 57.
     * Event description: triggered when adding forum element from the forum in add panel.
    
     * element_type - Type: string. Desc: recent post /
     *
     * instance_id - Type: guid.
     *
     * layout - Type: string. Desc: vertical/vertical_with_stats/horizontal/horizontal_with_stats
     *
     * msid - Type: guid. Desc: msid
     *
     * biToken - Type: guid.
     * @param {forumAddPanelForumElementAddedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.forumAddPanelForumElementAdded = function (params) {
        return this.bi.log(__assign({ evid: 57 }, params));
    };
    /**
    * @typedef {Object} bmBulkActionPostsMoveParams
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - msid
    * @property {string} origin - business_manager
    * @property {number} page_count - total page count
    * @property {number} page_nr - current page nr
    * @property {number} posts_count - selected posts count
    * @property {string} posts_format - discussion / question / all
    * @property {GUID} site_member_id - site member id
    * @property {GUID} target_category_id - target category id
    **/
    /**
     * Name: BM - Move posts to different category(bulk action). Evid: 602.
     * Event description: Event triggered when moving multiple posts in BM.
    
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: business_manager
     *
     * page_count - Type: numeric. Desc: total page count
     *
     * page_nr - Type: numeric. Desc: current page nr
     *
     * posts_count - Type: numeric. Desc: selected posts count
     *
     * posts_format - Type: string. Desc: discussion / question / all
     *
     * site_member_id - Type: guid. Desc: site member id
     *
     * target_category_id - Type: guid. Desc: target category id
     * @param {bmBulkActionPostsMoveParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bmBulkActionPostsMove = function (params) {
        return this.bi.log(__assign({ evid: 602 }, params));
    };
    /**
    * @typedef {Object} createPostIntentParams
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - msid
    * @property {string} origin - live / business_manager
    * @property {GUID} site_member_id - site_member_id
    * @property {GUID} visitor_id - visitor_id
    **/
    /**
     * Name: Create post intent. Evid: 79.
     * Event description: Event triggered when clicking on create new post button just before the choice of questions or discussions.
    
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: live / business_manager
     *
     * site_member_id - Type: guid. Desc: site_member_id
     *
     * visitor_id - Type: guid. Desc: visitor_id
     * @param {createPostIntentParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.createPostIntent = function (params) {
        return this.bi.log(__assign({ evid: 79 }, params));
    };
    /**
    * @typedef {Object} forumSettingsPostSortingOptionParams
    * @property {GUID} instance_id - instance id
    * @property {GUID} biToken - msid
    * @property {string} option - recent_activity / newest / most_comments / most_viewed / most_liked
    * @property {string} origin - ADI/ Editor
    * @property {GUID} site_member_id - site_member_id
    * @property {GUID} uuid - user id
    **/
    /**
     * Name: Forum settings: Post sorting option. Evid: 72.
     * Event description: The event is triggered when a user selects a new value in "sorting posting default" drop-down menu..
    
     * instance_id - Type: guid. Desc: instance id
     *
     * biToken - Type: guid. Desc: msid
     *
     * option - Type: string. Desc: recent_activity / newest / most_comments / most_viewed / most_liked
     *
     * origin - Type: string. Desc: ADI/ Editor
     *
     * site_member_id - Type: guid. Desc: site_member_id
     *
     * uuid - Type: guid. Desc: user id
     * @param {forumSettingsPostSortingOptionParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.forumSettingsPostSortingOption = function (params) {
        return this.bi.log(__assign({ evid: 72 }, params));
    };
    /**
    * @typedef {Object} forumSettingsSectionDesignChangedAdiParams
    * @property {GUID} instance_id - instance id
    * @property {GUID} biToken - msid
    * @property {string} origin - ADI / Editor
    * @property {GUID} site_member_id - site_member_id
    * @property {string} template_id - selected template id
    * @property {GUID} uuid - user id
    **/
    /**
     * Name: Forum settings: Section design changed (ADI). Evid: 77.
     * Event description: Event is triggered when a user clicks on a new design template on Section Design.
    
     * instance_id - Type: guid. Desc: instance id
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: ADI / Editor
     *
     * site_member_id - Type: guid. Desc: site_member_id
     *
     * template_id - Type: string. Desc: selected template id
     *
     * uuid - Type: guid. Desc: user id
     * @param {forumSettingsSectionDesignChangedAdiParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.forumSettingsSectionDesignChangedAdi = function (params) {
        return this.bi.log(__assign({ evid: 77 }, params));
    };
    /**
    * @typedef {Object} followCategoryWixAppParams
    * @property {GUID} app_id - app_id
    * @property {string} category_followed - the category_id that had been followed
    * @property {GUID} instance_id - null
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} msid - msid
    * @property {GUID} biToken - null
    * @property {string} origin - 'category_list'/'category_picker_inside_category'/'menu_inside_category'
    * @property {GUID} site_member_id - site_member_id
    * @property {string} type - 'follow' /'unfollow'
    * @property {GUID} uuid - uuid
    **/
    /**
     * Name: follow category Wix App. Evid: 58.
     * Event description: Event triggered when clicking on follow category button.
    
     * app_id - Type: guid. Desc: app_id
     *
     * category_followed - Type: string. Desc: the category_id that had been followed
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * msid - Type: guid. Desc: msid
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: 'category_list'/'category_picker_inside_category'/'menu_inside_category'
     *
     * site_member_id - Type: guid. Desc: site_member_id
     *
     * type - Type: string. Desc: 'follow' /'unfollow'
     *
     * uuid - Type: guid. Desc: uuid
     * @param {followCategoryWixAppParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.followCategoryWixApp = function (params) {
        return this.bi.log(__assign({ evid: 58 }, params));
    };
    /**
    * @typedef {Object} forumSettingsFontParams
    * @property {string} font - selected font
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} place - post title / post description / header title / header description
    * @property {GUID} uuid - uuid
    **/
    /**
     * Name: Forum settings: font. Evid: 52.
     * Event description: When font is selected.
    
     * font - Type: string. Desc: selected font
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * place - Type: string. Desc: post title / post description / header title / header description
     *
     * uuid - Type: guid. Desc: uuid
     * @param {forumSettingsFontParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.forumSettingsFont = function (params) {
        return this.bi.log(__assign({ evid: 52 }, params));
    };
    /**
    * @typedef {Object} forumSettingsShowSimilarQuestionsQaPostsParams
    * @property {GUID} instance_id - forum instance guid
    * @property {GUID} biToken - metasite guid
    * @property {string} option - on/off (default - on)
    * @property {string} origin - ADI / Editor
    * @property {GUID} site_member_id - site member id
    * @property {GUID} uuid - owner uuid
    **/
    /**
     * Name: Forum settings: show similar questions (Q&A posts). Evid: 75.
     * Event description: When a user clicks on the toggle in "forum-general"-> "show similar questions".
    
     * instance_id - Type: guid. Desc: forum instance guid
     *
     * biToken - Type: guid. Desc: metasite guid
     *
     * option - Type: string. Desc: on/off (default - on)
     *
     * origin - Type: string. Desc: ADI / Editor
     *
     * site_member_id - Type: guid. Desc: site member id
     *
     * uuid - Type: guid. Desc: owner uuid
     * @param {forumSettingsShowSimilarQuestionsQaPostsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.forumSettingsShowSimilarQuestionsQaPosts = function (params) {
        return this.bi.log(__assign({ evid: 75 }, params));
    };
    /**
    * @typedef {Object} followPostWixAppParams
    * @property {GUID} app_id - app_id
    * @property {GUID} instance_id - null
    * @property {GUID} msid - msid
    * @property {GUID} biToken - null
    * @property {string} origin - search_results, user_profile
    * @property {GUID} owner_id - uuid of post owner
    * @property {string} post_followed - the post_id that had been followed
    * @property {string} type - 'follow'/'unfollow'
    * @property {GUID} uuid - uuid
    **/
    /**
     * Name: Follow post Wix App. Evid: 59.
     * Event description: Event triggered when clicking on follow post in 3 dots menu.
    
     * app_id - Type: guid. Desc: app_id
     *
     * instance_id - Type: guid.
     *
     * msid - Type: guid. Desc: msid
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: search_results, user_profile
     *
     * owner_id - Type: guid. Desc: uuid of post owner
     *
     * post_followed - Type: string. Desc: the post_id that had been followed
     *
     * type - Type: string. Desc: 'follow'/'unfollow'
     *
     * uuid - Type: guid. Desc: uuid
     * @param {followPostWixAppParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.followPostWixApp = function (params) {
        return this.bi.log(__assign({ evid: 59 }, params));
    };
    /**
    * @typedef {Object} forumSettingsInputParams
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - known also as bIToken
    * @property {string} setting_input_json - JSON object with all properties
    **/
    /**
     * Name: forum settings input. Evid: 12.
     * Event description: Event triggered when users saves/publishes his site. with all the latest settings he chose.
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid. Desc: known also as bIToken
     *
     * setting_input_json - Type: string. Desc: JSON object with all properties
     * @param {forumSettingsInputParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.forumSettingsInput = function (params) {
        return this.bi.log(__assign({ evid: 12 }, params));
    };
    /**
    * @typedef {Object} postClickOnShareParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} origin - post share button / action button
    * @property {string} post_id - post id
    * @property {GUID} site_member_id - site_member_id
    * @property {string} type - post/comment/reply
    **/
    /**
     * Name: Post - click on share. Evid: 38.
     * Event description: When the user clicks on "share" to share post.
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: post share button / action button
     *
     * post_id - Type: string. Desc: post id
     *
     * site_member_id - Type: guid. Desc: site_member_id
     *
     * type - Type: string. Desc: post/comment/reply
     * @param {postClickOnShareParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.postClickOnShare = function (params) {
        return this.bi.log(__assign({ evid: 38 }, params));
    };
    /**
    * @typedef {Object} markAllNotificationsAsReadParams
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - msid
    * @property {GUID} site_member_id - site_member_id
    **/
    /**
     * Name: Mark all notifications as read. Evid: 80.
     * Event description: Event triggered when clicking on Mark all notifications as read.
    
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid. Desc: msid
     *
     * site_member_id - Type: guid. Desc: site_member_id
     * @param {markAllNotificationsAsReadParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.markAllNotificationsAsRead = function (params) {
        return this.bi.log(__assign({ evid: 80 }, params));
    };
    /**
    * @typedef {Object} advancedForumSettingsClickParams
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - msid
    * @property {string} origin - business_manager, forum_settings
    * @property {GUID} site_member_id - site_member_id
    * @property {GUID} uuid - uuid
    **/
    /**
     * Name: Advanced Forum settings click. Evid: 82.
     * Event description: Event triggered when click "For more forum settings. head to the Dashboard" in Forum --> Settings tab, or click "Forum Settings" in Business Manager.
    
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: business_manager, forum_settings
     *
     * site_member_id - Type: guid. Desc: site_member_id
     *
     * uuid - Type: guid. Desc: uuid
     * @param {advancedForumSettingsClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.advancedForumSettingsClick = function (params) {
        return this.bi.log(__assign({ evid: 82 }, params));
    };
    /**
    * @typedef {Object} clickOnPostForPostCommentAndReplyParams
    * @property {string} comment_id - comment id
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} post_id - post id
    * @property {string} type - (post,comment,reply)
    **/
    /**
     * Name: Click on post (for post, comment and reply). Evid: 24.
     * Event description: When the user clicks "post" on post, comment and reply.
    
     * comment_id - Type: string. Desc: comment id
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * post_id - Type: string. Desc: post id
     *
     * type - Type: string. Desc: (post,comment,reply)
     * @param {clickOnPostForPostCommentAndReplyParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickOnPostForPostCommentAndReply = function (params) {
        return this.bi.log(__assign({ evid: 24 }, params));
    };
    /**
    * @typedef {Object} mainPageOpenedParams
    * @property {GUID} instance_id - null
    * @property {string} main_display_type - list_of_posts / list_of_categories
    * @property {GUID} biToken - null
    * @property {string} origin - wix_site, external_link (url, google), breadcrumbs, list_icon (list_icon is from mobile only (hamburger icon)), post_sidebar, oneapp_tab, dropdown (dropdown is for mobile), widget
    * @property {GUID} site_member_id - site_member_id
    **/
    /**
     * Name: main page opened. Evid: 501.
     * Event description: Event triggered when categories (main) page opened.
    
     * instance_id - Type: guid.
     *
     * main_display_type - Type: string. Desc: list_of_posts / list_of_categories
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: wix_site, external_link (url, google), breadcrumbs, list_icon (list_icon is from mobile only (hamburger icon)), post_sidebar, oneapp_tab, dropdown (dropdown is for mobile), widget
     *
     * site_member_id - Type: guid. Desc: site_member_id
     * @param {mainPageOpenedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.mainPageOpened = function (params) {
        return this.bi.log(__assign({ evid: 501 }, params));
    };
    /**
    * @typedef {Object} commentThreeDotsActionButtonParams
    * @property {string} comment_id - comment id
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} post_id - post id
    * @property {GUID} site_member_id - site_member_id
    * @property {string} value - the option chosen - (view profile, like comment etc)
    **/
    /**
     * Name: Comment - three dots - action button. Evid: 22.
     * Event description: When the user clicks on action button from the menu opened from pressing on the three dots on a comment.
    
     * comment_id - Type: string. Desc: comment id
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * post_id - Type: string. Desc: post id
     *
     * site_member_id - Type: guid. Desc: site_member_id
     *
     * value - Type: string. Desc: the option chosen - (view profile, like comment etc)
     * @param {commentThreeDotsActionButtonParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.commentThreeDotsActionButton = function (params) {
        return this.bi.log(__assign({ evid: 22 }, params));
    };
    /**
    * @typedef {Object} forumSettingsCommunitySettingsParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} type - on/off
    * @property {GUID} uuid - uuid
    **/
    /**
     * Name: Forum settings: community settings. Evid: 50.
     * Event description: When toggle is switched on/off.
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * type - Type: string. Desc: on/off
     *
     * uuid - Type: guid. Desc: uuid
     * @param {forumSettingsCommunitySettingsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.forumSettingsCommunitySettings = function (params) {
        return this.bi.log(__assign({ evid: 50 }, params));
    };
    /**
    * @typedef {Object} commentReportedWixAppParams
    * @property {GUID} app_id - app_id
    * @property {GUID} instance_id - null
    * @property {GUID} msid - msid
    * @property {GUID} biToken - null
    * @property {GUID} owner_id - uuid of post owner
    * @property {string} post_followed - the post_id that had been followed
    * @property {string} type - 'spam'/'violence'/'harrasment'/'nudity or sexual activity'/'other'
    * @property {GUID} uuid - uuid
    **/
    /**
     * Name: Comment reported - Wix App. Evid: 60.
     * Event description: Event triggered when a comment is reported in Wix App.
    
     * app_id - Type: guid. Desc: app_id
     *
     * instance_id - Type: guid.
     *
     * msid - Type: guid. Desc: msid
     *
     * biToken - Type: guid.
     *
     * owner_id - Type: guid. Desc: uuid of post owner
     *
     * post_followed - Type: string. Desc: the post_id that had been followed
     *
     * type - Type: string. Desc: 'spam'/'violence'/'harrasment'/'nudity or sexual activity'/'other'
     *
     * uuid - Type: guid. Desc: uuid
     * @param {commentReportedWixAppParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.commentReportedWixApp = function (params) {
        return this.bi.log(__assign({ evid: 60 }, params));
    };
    /**
    * @typedef {Object} forumLoadInEditorSuccessParams
    * @property {GUID} instance_id - Intance id of the specific Forum instance
    * @property {GUID} biToken - Metasite guid
    **/
    /**
     * Name: Forum load in Editor success. Evid: 62.
     * Event description: Forum was loaded in the editor successfully.
    
     * instance_id - Type: guid. Desc: Intance id of the specific Forum instance
     *
     * biToken - Type: guid. Desc: Metasite guid
     * @param {forumLoadInEditorSuccessParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.forumLoadInEditorSuccess = function (params) {
        return this.bi.log(__assign({ evid: 62 }, params));
    };
    /**
    * @typedef {Object} forumSettingsPostToolbarDisplayOptionsChangedParams
    * @property {GUID} instance_id - instance id
    * @property {GUID} biToken - msid
    * @property {string} options - CSV list of all selected options: e.g.: image, video, divider, html, code_block, file_upload, giphy, emoji
    * @property {string} origin - ADI / Editor
    * @property {GUID} site_member_id - site_member_id
    * @property {GUID} uuid - user id
    **/
    /**
     * Name: Forum settings: post toolbar display options changed. Evid: 76.
     * Event description: Event is triggered when a user selects or deselect one or more options in the “post toolbar display option” section.
    
     * instance_id - Type: guid. Desc: instance id
     *
     * biToken - Type: guid. Desc: msid
     *
     * options - Type: string. Desc: CSV list of all selected options: e.g.: image, video, divider, html, code_block, file_upload, giphy, emoji
     *
     * origin - Type: string. Desc: ADI / Editor
     *
     * site_member_id - Type: guid. Desc: site_member_id
     *
     * uuid - Type: guid. Desc: user id
     * @param {forumSettingsPostToolbarDisplayOptionsChangedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.forumSettingsPostToolbarDisplayOptionsChanged = function (params) {
        return this.bi.log(__assign({ evid: 76 }, params));
    };
    /**
    * @typedef {Object} categoriesCreateNewCategoryCreateParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} name - name of the category created
    * @property {string} type - category/subcategory
    **/
    /**
     * Name: Categories - create new category - create. Evid: 31.
     * Event description: When the user clicks on create in the create new category page.
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * name - Type: string. Desc: name of the category created
     *
     * type - Type: string. Desc: category/subcategory
     * @param {categoriesCreateNewCategoryCreateParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.categoriesCreateNewCategoryCreate = function (params) {
        return this.bi.log(__assign({ evid: 31 }, params));
    };
    /**
    * @typedef {Object} postListOpenedParams
    * @property {string} category_id - category_id guid
    * @property {string} category_name - category_slug
    * @property {string} category_slug - category_slug
    * @property {GUID} instance_id - null
    * @property {string} main_display_type - list_of_posts / list_of_categories
    * @property {GUID} biToken - null
    * @property {string} origin - categories_page, external_link (url, google), breadcrumbs, wix_site, post_sidebar, business_manager, post_category_indication(oneApp)
    * @property {GUID} site_member_id - site_member_id
    * @property {number} total_pages - how many pages with posts (in case there are more 20 posts)
    **/
    /**
     * Name: post list opened. Evid: 503.
     * Event description: Event triggered when forum post list is opened (contents of a category).
    
     * category_id - Type: string. Desc: category_id guid
     *
     * category_name - Type: string. Desc: category_slug
     *
     * category_slug - Type: string. Desc: category_slug
     *
     * instance_id - Type: guid.
     *
     * main_display_type - Type: string. Desc: list_of_posts / list_of_categories
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: categories_page, external_link (url, google), breadcrumbs, wix_site, post_sidebar, business_manager, post_category_indication(oneApp)
     *
     * site_member_id - Type: guid. Desc: site_member_id
     *
     * total_pages - Type: numeric. Desc: how many pages with posts (in case there are more 20 posts)
     * @param {postListOpenedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.postListOpened = function (params) {
        return this.bi.log(__assign({ evid: 503 }, params));
    };
    /**
    * @typedef {Object} forumSettingsLoginFromForumMenuParams
    * @property {string} editor_view_mode - desktop/mobile
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} option - on/off
    * @property {string} origin - ADI / Editor
    * @property {GUID} uuid - uuid
    **/
    /**
     * Name: Forum settings: login from forum menu. Evid: 45.
     * Event description: When user switch toggle.
    
     * editor_view_mode - Type: string. Desc: desktop/mobile
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * option - Type: string. Desc: on/off
     *
     * origin - Type: string. Desc: ADI / Editor
     *
     * uuid - Type: guid. Desc: uuid
     * @param {forumSettingsLoginFromForumMenuParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.forumSettingsLoginFromForumMenu = function (params) {
        return this.bi.log(__assign({ evid: 45 }, params));
    };
    /**
    * @typedef {Object} clickOnAddGifParams
    * @property {string} comment_id - comment id
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} post_id - post id
    * @property {string} type - comment/post/reply
    **/
    /**
     * Name: Click on Add GIF. Evid: 25.
     * Event description: When the user clicks on add GIF in a comment/post/reply.
    
     * comment_id - Type: string. Desc: comment id
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * post_id - Type: string. Desc: post id
     *
     * type - Type: string. Desc: comment/post/reply
     * @param {clickOnAddGifParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickOnAddGif = function (params) {
        return this.bi.log(__assign({ evid: 25 }, params));
    };
    /**
    * @typedef {Object} postClickOnMapParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} post_id - post id
    **/
    /**
     * Name: Post - click on map. Evid: 37.
     * Event description: When the user clicks on map or location in a post.
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * post_id - Type: string. Desc: post id
     * @param {postClickOnMapParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.postClickOnMap = function (params) {
        return this.bi.log(__assign({ evid: 37 }, params));
    };
    /**
    * @typedef {Object} forumMemberSignupSettingsBecomingAMemberParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} option - Everyone/People I approve
    * @property {GUID} uuid - uuid
    **/
    /**
     * Name: Forum member signup settings: becoming a member. Evid: 46.
     * Event description: When user change who can be a member.
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * option - Type: string. Desc: Everyone/People I approve
     *
     * uuid - Type: guid. Desc: uuid
     * @param {forumMemberSignupSettingsBecomingAMemberParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.forumMemberSignupSettingsBecomingAMember = function (params) {
        return this.bi.log(__assign({ evid: 46 }, params));
    };
    /**
    * @typedef {Object} commentDeletedParams
    * @property {string} comment_id - comment id
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} post_id - post id
    **/
    /**
     * Name: comment deleted. Evid: 40.
     * Event description: When comment is deleted successfully.
    
     * comment_id - Type: string. Desc: comment id
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * post_id - Type: string. Desc: post id
     * @param {commentDeletedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.commentDeleted = function (params) {
        return this.bi.log(__assign({ evid: 40 }, params));
    };
    /**
    * @typedef {Object} movePostToDifferentCategoryParams
    * @property {string} category_id - final category id
    * @property {string} category_posts_format - discussion / question / all
    * @property {GUID} instance_id - instance id
    * @property {GUID} biToken - msid
    * @property {string} origin - feed_page, post_page, search_results, user_profile, business_manager
    * @property {string} post_id - post_id
    * @property {GUID} site_member_id - site member id
    * @property {string} source_category_id - source category id
    * @property {string} source_category_posts_format - discussion / question / all
    * @property {GUID} visitor_id - visitor_id
    **/
    /**
     * Name: Move post to different category. Evid: 579.
     * Event description: triggered when Move Post button pressed.
    
     * category_id - Type: string. Desc: final category id
     *
     * category_posts_format - Type: string. Desc: discussion / question / all
     *
     * instance_id - Type: guid. Desc: instance id
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: feed_page, post_page, search_results, user_profile, business_manager
     *
     * post_id - Type: string. Desc: post_id
     *
     * site_member_id - Type: guid. Desc: site member id
     *
     * source_category_id - Type: string. Desc: source category id
     *
     * source_category_posts_format - Type: string. Desc: discussion / question / all
     *
     * visitor_id - Type: guid. Desc: visitor_id
     * @param {movePostToDifferentCategoryParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.movePostToDifferentCategory = function (params) {
        return this.bi.log(__assign({ evid: 579 }, params));
    };
    /**
    * @typedef {Object} createPostClickParams
    * @property {string} button_position - top, bottom - (bottom only for classic)
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} origin - live / business_manager
    * @property {string} posts_format - discussion / question
    **/
    /**
     * Name: create post click. Evid: 505.
     * Event description: Event triggered when clicking on create new post button.
    
     * button_position - Type: string. Desc: top, bottom - (bottom only for classic)
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: live / business_manager
     *
     * posts_format - Type: string. Desc: discussion / question
     * @param {createPostClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.createPostClick = function (params) {
        return this.bi.log(__assign({ evid: 505 }, params));
    };
    /**
    * @typedef {Object} forumNameAndDescriptionChangeParams
    * @property {GUID} instance_id - null
    * @property {number} length - length of value
    * @property {GUID} biToken - msid
    * @property {string} origin - ADI; Editor
    * @property {GUID} site_member_id - site_member_id
    * @property {string} type - forum_name; forum_description; forum_title
    * @property {GUID} uuid - uuid
    **/
    /**
     * Name: Forum name and description change. Evid: 78.
     * Event description: When user clicks to write/change "Forum Name"/"Forum Description" and then clicks outside the writing place and the value is different, event should fire. When "Forum Name" place is changed, then "type"  = forum_name. When "Forum Description" place is changed, then "type" = forum_description. Field "length" should calculate the length of "Forum Name"/"Forum description"..
    
     * instance_id - Type: guid.
     *
     * length - Type: numeric. Desc: length of value
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: ADI; Editor
     *
     * site_member_id - Type: guid. Desc: site_member_id
     *
     * type - Type: string. Desc: forum_name; forum_description; forum_title
     *
     * uuid - Type: guid. Desc: uuid
     * @param {forumNameAndDescriptionChangeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.forumNameAndDescriptionChange = function (params) {
        return this.bi.log(__assign({ evid: 78 }, params));
    };
    /**
    * @typedef {Object} forumSettingsPickForumSubjectParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} type_of_subject - type of subject which user chose
    * @property {GUID} uuid - uuid
    **/
    /**
     * Name: Forum settings: pick forum subject. Evid: 41.
     * Event description: When user clicks on subject name.
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * type_of_subject - Type: string. Desc: type of subject which user chose
     *
     * uuid - Type: guid. Desc: uuid
     * @param {forumSettingsPickForumSubjectParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.forumSettingsPickForumSubject = function (params) {
        return this.bi.log(__assign({ evid: 41 }, params));
    };
    /**
    * @typedef {Object} newItemAddedParams
    * @property {GUID} instance_id - null
    * @property {string} item - Link/mention/image/gif/video
    * @property {number} media_size - file size in Kb
    * @property {string} media_source - "gallery" or "camera"
    * @property {GUID} biToken - null
    * @property {GUID} site_member_id - site_member_id
    * @property {string} type - Post/comment/reply
    **/
    /**
     * Name: New item added. Evid: 36.
     * Event description: When a new item (link/mention/image/gif) was added to post/comment/reply.
    
     * instance_id - Type: guid.
     *
     * item - Type: string. Desc: Link/mention/image/gif/video
     *
     * media_size - Type: numeric. Desc: file size in Kb
     *
     * media_source - Type: string. Desc: "gallery" or "camera"
     *
     * biToken - Type: guid.
     *
     * site_member_id - Type: guid. Desc: site_member_id
     *
     * type - Type: string. Desc: Post/comment/reply
     * @param {newItemAddedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.newItemAdded = function (params) {
        return this.bi.log(__assign({ evid: 36 }, params));
    };
    /**
    * @typedef {Object} forumTabInBmOpenedParams
    * @property {GUID} instance_id - instance_id
    * @property {GUID} bi_token - msid
    * @property {GUID} biToken - null
    * @property {string} origin - "sidebar", "editor_gfpp", "editor_app_settings", "adi_manage", "adi_pages_panel", "dashboard widget", "manage tab"
    * @property {GUID} site_member_id - site_member_id
    * @property {string} tab_name - Opened Tab in Forum Back Office ("Posts", "Categories"
    **/
    /**
     * Name: Forum tab in BM opened. Evid: 419.
     * Event description: Tab in Forum Manager opened.
    
     * instance_id - Type: guid. Desc: instance_id
     *
     * bi_token - Type: guid. Desc: msid
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: "sidebar", "editor_gfpp", "editor_app_settings", "adi_manage", "adi_pages_panel", "dashboard widget", "manage tab"
     *
     * site_member_id - Type: guid. Desc: site_member_id
     *
     * tab_name - Type: string. Desc: Opened Tab in Forum Back Office ("Posts", "Categories"
     * @param {forumTabInBmOpenedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.forumTabInBmOpened = function (params) {
        return this.bi.log(__assign({ evid: 419 }, params));
    };
    /**
    * @typedef {Object} paidPlansIntegrationFallbackToastOpenedParams
    * @property {GUID} instance_id - forum instance id
    * @property {GUID} biToken - msid
    * @property {GUID} site_member_id - site member id
    * @property {GUID} uuid - uuid
    **/
    /**
     * Name: Paid Plans Integration fallback toast opened. Evid: 67.
     * Event description: Event triggered when a toast is displayed after automatically adding Paid Plans pages to the site fails.
    
     * instance_id - Type: guid. Desc: forum instance id
     *
     * biToken - Type: guid. Desc: msid
     *
     * site_member_id - Type: guid. Desc: site member id
     *
     * uuid - Type: guid. Desc: uuid
     * @param {paidPlansIntegrationFallbackToastOpenedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.paidPlansIntegrationFallbackToastOpened = function (params) {
        return this.bi.log(__assign({ evid: 67 }, params));
    };
    /**
    * @typedef {Object} categoriesEditCategorySaveParams
    * @property {string} access_groups_json - Json with connected selected_member access entity guids
    * @property {string} applicationType - OneApp / Web
    * @property {number} badge_count - How many badges are added to access category
    * @property {number} badge_member_count - How many members having selected badges got access to category
    * @property {string} category_access - everyone / members_only / selected_members
    * @property {string} category_id - current category id
    * @property {GUID} instance_id - null
    * @property {boolean} is_category_image_set - if the user has set category image
    * @property {boolean} isChanged - if the user has changed anything
    * @property {boolean} is_oneapp_image_set - if the user has set additional (possible in OneApp only) category image
    * @property {number} member_count - How many members are added to access category
    * @property {GUID} biToken - null
    * @property {string} name - name of the category
    * @property {string} origin - settings (value: appSettings) / live site (value:categoriesManager)
    * @property {number} paid_plan_count - How many paid plans are added to category
    * @property {number} paid_plan_member_count - How many members having selected paid plans got access to category
    * @property {string} posts_format - discussion / question / all
    * @property {string} prev_category_access - Previous value (before save): everyone / members_only / selected_members
    * @property {number} role_count - How many roles are added to access category
    * @property {number} role_member_count - How many members having selected roles got access to category
    * @property {GUID} site_member_id - site_member_id
    * @property {string} type - category/subcategory
    * @property {boolean} visible_to_everyone - for Selected Members only: "true" - when visible to all users, "false" - visible only to users with access. Null for Everyone and Members Only.
    * @property {string} who_can_create_posts - value of section "Who can create posts in this category?": all_members / admins_and_moderators
    **/
    /**
     * Name: Categories - Edit category - save. Evid: 32.
     * Event description: When the user clicks save in the edit category page.
    
     * access_groups_json - Type: string. Desc: Json with connected selected_member access entity guids
     *
     * applicationType - Type: string. Desc: OneApp / Web
     *
     * badge_count - Type: numeric. Desc: How many badges are added to access category
     *
     * badge_member_count - Type: numeric. Desc: How many members having selected badges got access to category
     *
     * category_access - Type: string. Desc: everyone / members_only / selected_members
     *
     * category_id - Type: string. Desc: current category id
     *
     * instance_id - Type: guid.
     *
     * is_category_image_set - Type: bool. Desc: if the user has set category image
     *
     * isChanged - Type: bool. Desc: if the user has changed anything
     *
     * is_oneapp_image_set - Type: bool. Desc: if the user has set additional (possible in OneApp only) category image
     *
     * member_count - Type: numeric. Desc: How many members are added to access category
     *
     * biToken - Type: guid.
     *
     * name - Type: string. Desc: name of the category
     *
     * origin - Type: string. Desc: settings (value: appSettings) / live site (value:categoriesManager)
     *
     * paid_plan_count - Type: numeric. Desc: How many paid plans are added to category
     *
     * paid_plan_member_count - Type: numeric. Desc: How many members having selected paid plans got access to category
     *
     * posts_format - Type: string. Desc: discussion / question / all
     *
     * prev_category_access - Type: string. Desc: Previous value (before save): everyone / members_only / selected_members
     *
     * role_count - Type: numeric. Desc: How many roles are added to access category
     *
     * role_member_count - Type: numeric. Desc: How many members having selected roles got access to category
     *
     * site_member_id - Type: guid. Desc: site_member_id
     *
     * type - Type: string. Desc: category/subcategory
     *
     * visible_to_everyone - Type: bool. Desc: for Selected Members only: "true" - when visible to all users, "false" - visible only to users with access. Null for Everyone and Members Only.
     *
     * who_can_create_posts - Type: string. Desc: value of section "Who can create posts in this category?": all_members / admins_and_moderators
     * @param {categoriesEditCategorySaveParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.categoriesEditCategorySave = function (params) {
        return this.bi.log(__assign({ evid: 32 }, params));
    };
    /**
    * @typedef {Object} forumSettingsShowNewPostsParams
    * @property {string} editor_view_mode - desktop/mobile
    * @property {GUID} instance_id - forum instance guid
    * @property {GUID} biToken - metasite guid
    * @property {string} option - on/off (default - on)
    * @property {GUID} uuid - owner uuid
    **/
    /**
     * Name: Forum settings: show new posts. Evid: 64.
     * Event description: When the user clicks on toggle in layout-> show new posts.
    
     * editor_view_mode - Type: string. Desc: desktop/mobile
     *
     * instance_id - Type: guid. Desc: forum instance guid
     *
     * biToken - Type: guid. Desc: metasite guid
     *
     * option - Type: string. Desc: on/off (default - on)
     *
     * uuid - Type: guid. Desc: owner uuid
     * @param {forumSettingsShowNewPostsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.forumSettingsShowNewPosts = function (params) {
        return this.bi.log(__assign({ evid: 64 }, params));
    };
    /**
    * @typedef {Object} categoryNewCategoryAddedParams
    * @property {string} access_groups_json - Json with connected selected_member access entity guids
    * @property {string} applicationType - OneApp / Web
    * @property {number} badge_count - How many badges are added to access category
    * @property {number} badge_member_count - How many members having selected badges got access to category
    * @property {string} category_access - everyone / members_only / selected_members
    * @property {string} category_id - category id
    * @property {GUID} instance_id - null
    * @property {boolean} is_category_image_set - if the user has set category image
    * @property {boolean} is_oneapp_image_set - if the user has set additional (possible in OneApp only) category image
    * @property {number} member_count - How many members are added to access category
    * @property {GUID} biToken - null
    * @property {string} name - name of the category
    * @property {string} origin - settings (value: appSettings) / live site (value:categoriesManager)
    * @property {number} paid_plan_count - How many paid plans are added to access category
    * @property {number} paid_plan_member_count - How many members having selected paid plans got access to category
    * @property {string} posts_format - discussion / question / all
    * @property {number} role_count - How many roles are added to access category
    * @property {number} role_member_count - How many members having selected roles got access to category
    * @property {GUID} site_member_id - site_member_id
    * @property {string} type - category/subcategory
    * @property {boolean} visible_to_everyone - For Selected Members only: "true" - when visible to all users, "false" - visible only to users with access. Null for Everyone and Members Only.
    * @property {string} who_can_create_posts - value of section "Who can create posts in this category?": all_members / admins_and_moderators
    **/
    /**
     * Name: Category - new category added. Evid: 33.
     * Event description: When new category was added successfully.
    
     * access_groups_json - Type: string. Desc: Json with connected selected_member access entity guids
     *
     * applicationType - Type: string. Desc: OneApp / Web
     *
     * badge_count - Type: numeric. Desc: How many badges are added to access category
     *
     * badge_member_count - Type: numeric. Desc: How many members having selected badges got access to category
     *
     * category_access - Type: string. Desc: everyone / members_only / selected_members
     *
     * category_id - Type: string. Desc: category id
     *
     * instance_id - Type: guid.
     *
     * is_category_image_set - Type: bool. Desc: if the user has set category image
     *
     * is_oneapp_image_set - Type: bool. Desc: if the user has set additional (possible in OneApp only) category image
     *
     * member_count - Type: numeric. Desc: How many members are added to access category
     *
     * biToken - Type: guid.
     *
     * name - Type: string. Desc: name of the category
     *
     * origin - Type: string. Desc: settings (value: appSettings) / live site (value:categoriesManager)
     *
     * paid_plan_count - Type: numeric. Desc: How many paid plans are added to access category
     *
     * paid_plan_member_count - Type: numeric. Desc: How many members having selected paid plans got access to category
     *
     * posts_format - Type: string. Desc: discussion / question / all
     *
     * role_count - Type: numeric. Desc: How many roles are added to access category
     *
     * role_member_count - Type: numeric. Desc: How many members having selected roles got access to category
     *
     * site_member_id - Type: guid. Desc: site_member_id
     *
     * type - Type: string. Desc: category/subcategory
     *
     * visible_to_everyone - Type: bool. Desc: For Selected Members only: "true" - when visible to all users, "false" - visible only to users with access. Null for Everyone and Members Only.
     *
     * who_can_create_posts - Type: string. Desc: value of section "Who can create posts in this category?": all_members / admins_and_moderators
     * @param {categoryNewCategoryAddedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.categoryNewCategoryAdded = function (params) {
        return this.bi.log(__assign({ evid: 33 }, params));
    };
    /**
    * @typedef {Object} paidPlansIntegrationFallbackToastClickedParams
    * @property {GUID} instance_id - forum instance id
    * @property {GUID} biToken - msid
    * @property {GUID} site_member_id - site member id
    * @property {GUID} uuid - uuid
    **/
    /**
     * Name: Paid Plans Integration Fallback toast clicked. Evid: 68.
     * Event description: Event triggered when a toast is clicked after automatically adding Paid Plans pages to the site fails.
    
     * instance_id - Type: guid. Desc: forum instance id
     *
     * biToken - Type: guid. Desc: msid
     *
     * site_member_id - Type: guid. Desc: site member id
     *
     * uuid - Type: guid. Desc: uuid
     * @param {paidPlansIntegrationFallbackToastClickedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.paidPlansIntegrationFallbackToastClicked = function (params) {
        return this.bi.log(__assign({ evid: 68 }, params));
    };
    /**
    * @typedef {Object} postSharedSuccessfullyParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} post_id - post id
    **/
    /**
     * Name: Post shared successfully. Evid: 39.
     * Event description: When post shared successfully.
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * post_id - Type: string. Desc: post id
     * @param {postSharedSuccessfullyParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.postSharedSuccessfully = function (params) {
        return this.bi.log(__assign({ evid: 39 }, params));
    };
    /**
    * @typedef {Object} categoriesCategoryDeletedParams
    * @property {string} applicationType - OneApp / Web
    * @property {string} category_access - everyone / members_only / selected_members
    * @property {string} category_id - category guid
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} name - name of the category
    * @property {string} origin - settings (value: appSettings) / live site (value:categoriesManager)
    * @property {string} place - unused
    * @property {string} posts_format - discussion / question / all
    * @property {GUID} site_member_id - site_member_id
    * @property {string} type - category/subcategory
    * @property {string} who_can_create_posts - value of section "Who can create posts in this category?": all_members / admins_and_moderators
    **/
    /**
     * Name: Categories - category deleted. Evid: 34.
     * Event description: When a category is deleted successfully.
    
     * applicationType - Type: string. Desc: OneApp / Web
     *
     * category_access - Type: string. Desc: everyone / members_only / selected_members
     *
     * category_id - Type: string. Desc: category guid
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * name - Type: string. Desc: name of the category
     *
     * origin - Type: string. Desc: settings (value: appSettings) / live site (value:categoriesManager)
     *
     * place - Type: string. Desc: unused
     *
     * posts_format - Type: string. Desc: discussion / question / all
     *
     * site_member_id - Type: guid. Desc: site_member_id
     *
     * type - Type: string. Desc: category/subcategory
     *
     * who_can_create_posts - Type: string. Desc: value of section "Who can create posts in this category?": all_members / admins_and_moderators
     * @param {categoriesCategoryDeletedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.categoriesCategoryDeleted = function (params) {
        return this.bi.log(__assign({ evid: 34 }, params));
    };
    /**
    * @typedef {Object} adiForumSettingsForumSectionsSelectionParams
    * @property {GUID} instance_id - instance id
    * @property {GUID} biToken - msid
    * @property {string} option - general_settings / category_list / post_list / post
    * @property {string} origin - ADI / Editor
    * @property {GUID} site_member_id - site_member_id
    * @property {GUID} uuid - user id
    **/
    /**
     * Name: ADI Forum settings: forum sections selection. Evid: 73.
     * Event description: Event is triggered when user clicks on one of the options in "Forum Sections" in ADI.
    
     * instance_id - Type: guid. Desc: instance id
     *
     * biToken - Type: guid. Desc: msid
     *
     * option - Type: string. Desc: general_settings / category_list / post_list / post
     *
     * origin - Type: string. Desc: ADI / Editor
     *
     * site_member_id - Type: guid. Desc: site_member_id
     *
     * uuid - Type: guid. Desc: user id
     * @param {adiForumSettingsForumSectionsSelectionParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.adiForumSettingsForumSectionsSelection = function (params) {
        return this.bi.log(__assign({ evid: 73 }, params));
    };
    /**
    * @typedef {Object} memberSignupSettingsSwitchedSettingsPageParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} page_name - General/Social&community/Policies
    * @property {GUID} uuid - uuid
    **/
    /**
     * Name: Member signup settings: switched settings page. Evid: 48.
     * Event description: When user switch member signup settings page.
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * page_name - Type: string. Desc: General/Social&community/Policies
     *
     * uuid - Type: guid. Desc: uuid
     * @param {memberSignupSettingsSwitchedSettingsPageParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.memberSignupSettingsSwitchedSettingsPage = function (params) {
        return this.bi.log(__assign({ evid: 48 }, params));
    };
    /**
    * @typedef {Object} forumSettingsShowSubcategoriesParams
    * @property {GUID} instance_id - forum instance guid
    * @property {GUID} biToken - metasite guid
    * @property {string} option - on/off (default - off)
    * @property {string} origin - ADI / Editor
    * @property {GUID} site_member_id - member id
    * @property {GUID} uuid - owner uuid
    **/
    /**
     * Name: Forum settings: show subcategories. Evid: 63.
     * Event description: When the user clicks on toggle in layout-> show subcategories.
    
     * instance_id - Type: guid. Desc: forum instance guid
     *
     * biToken - Type: guid. Desc: metasite guid
     *
     * option - Type: string. Desc: on/off (default - off)
     *
     * origin - Type: string. Desc: ADI / Editor
     *
     * site_member_id - Type: guid. Desc: member id
     *
     * uuid - Type: guid. Desc: owner uuid
     * @param {forumSettingsShowSubcategoriesParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.forumSettingsShowSubcategories = function (params) {
        return this.bi.log(__assign({ evid: 63 }, params));
    };
    /**
    * @typedef {Object} forumsSettingsPostLimiterParams
    * @property {GUID} instance_id - instance id
    * @property {GUID} biToken - metasite id
    * @property {string} option - "no_limit", "1_per_day", "5_per_day", "10_per_day" (default "10_per_day")
    * @property {GUID} uuid - owner uuid
    **/
    /**
     * Name: Forums settings: post limiter. Evid: 65.
     * Event description: triggered when owner changes the "limit posts for members' first week" setting.
    
     * instance_id - Type: guid. Desc: instance id
     *
     * biToken - Type: guid. Desc: metasite id
     *
     * option - Type: string. Desc: "no_limit", "1_per_day", "5_per_day", "10_per_day" (default "10_per_day")
     *
     * uuid - Type: guid. Desc: owner uuid
     * @param {forumsSettingsPostLimiterParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.forumsSettingsPostLimiter = function (params) {
        return this.bi.log(__assign({ evid: 65 }, params));
    };
    /**
    * @typedef {Object} categoryThreeDotsActionButtonParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} name - name of the category
    * @property {string} origin - (manage forum, feed etc)
    * @property {string} type - category/subcategory
    * @property {string} value - name of the action button clicked
    **/
    /**
     * Name: Category - three dots - action button. Evid: 28.
     * Event description: When the user clicks on one of the action buttons in three dots  menu on one of the categories.
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * name - Type: string. Desc: name of the category
     *
     * origin - Type: string. Desc: (manage forum, feed etc)
     *
     * type - Type: string. Desc: category/subcategory
     *
     * value - Type: string. Desc: name of the action button clicked
     * @param {categoryThreeDotsActionButtonParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.categoryThreeDotsActionButton = function (params) {
        return this.bi.log(__assign({ evid: 28 }, params));
    };
    /**
    * @typedef {Object} editorSettingsOpenedParams
    * @property {string} app_id - app_id
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - msid
    * @property {string} origin - ADI / editor
    **/
    /**
     * Name: Click on App Settings. Evid: 85.
     * Event description: Click on App settings in Editor or ADI platforms.
    
     * app_id - Type: string. Desc: app_id
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: ADI / editor
     * @param {editorSettingsOpenedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.editorSettingsOpened = function (params) {
        return this.bi.log(__assign({ evid: 85 }, params));
    };
    /**
    * @typedef {Object} postClickOnReactionParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} post_id - post id
    * @property {string} role - owner/member
    * @property {string} target - comment, post, reply
    * @property {string} type - type of reaction (emoji, heart)
    **/
    /**
     * Name: Post - click on reaction. Evid: 14.
     * Event description: When the user clicks on reactions icon to add reaction.
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * post_id - Type: string. Desc: post id
     *
     * role - Type: string. Desc: owner/member
     *
     * target - Type: string. Desc: comment, post, reply
     *
     * type - Type: string. Desc: type of reaction (emoji, heart)
     * @param {postClickOnReactionParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.postClickOnReaction = function (params) {
        return this.bi.log(__assign({ evid: 14 }, params));
    };
    /**
    * @typedef {Object} categoriesCloseAccessModalWindowParams
    * @property {string} access_type - members / roles / badges / paid_plans
    * @property {string} category_id - category id guid
    * @property {GUID} instance_id - forum instance id
    * @property {boolean} items_updated - if (member/badge/pp/role) was added/removed to the list or updated(renamed/changed icon etc)
    * @property {GUID} biToken - msid
    * @property {GUID} site_member_id - site member id
    * @property {GUID} uuid - uuid
    **/
    /**
     * Name: Categories - close access modal window. Evid: 584.
     * Event description: Event triggered when user closes access modal window to edit Roles/Badges/Paid Plans.
    
     * access_type - Type: string. Desc: members / roles / badges / paid_plans
     *
     * category_id - Type: string. Desc: category id guid
     *
     * instance_id - Type: guid. Desc: forum instance id
     *
     * items_updated - Type: bool. Desc: if (member/badge/pp/role) was added/removed to the list or updated(renamed/changed icon etc)
     *
     * biToken - Type: guid. Desc: msid
     *
     * site_member_id - Type: guid. Desc: site member id
     *
     * uuid - Type: guid. Desc: uuid
     * @param {categoriesCloseAccessModalWindowParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.categoriesCloseAccessModalWindow = function (params) {
        return this.bi.log(__assign({ evid: 584 }, params));
    };
    /**
    * @typedef {Object} oneAppPhotoOrVideoSelectedForUploadParams
    * @property {string} comment_id - comment id
    * @property {string} file_type - "image" or "video"
    * @property {GUID} instance_id - instance id
    * @property {number} media_size - media size in Kb
    * @property {GUID} biToken - msid
    * @property {string} origin - post
    * @property {string} post_id - post id
    * @property {GUID} site_member_id - site_member_id
    **/
    /**
     * Name: OneApp - Photo or Video selected for upload. Evid: 66.
     * Event description: When media file(video or image) is selected and uploading process starts (only for posts).
    
     * comment_id - Type: string. Desc: comment id
     *
     * file_type - Type: string. Desc: "image" or "video"
     *
     * instance_id - Type: guid. Desc: instance id
     *
     * media_size - Type: numeric. Desc: media size in Kb
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: post
     *
     * post_id - Type: string. Desc: post id
     *
     * site_member_id - Type: guid. Desc: site_member_id
     * @param {oneAppPhotoOrVideoSelectedForUploadParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.oneAppPhotoOrVideoSelectedForUpload = function (params) {
        return this.bi.log(__assign({ evid: 66 }, params));
    };
    /**
    * @typedef {Object} forumMemberSignupSettingsWhichOptionShowsFirstParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} option - New member signup/Existing member login
    * @property {GUID} uuid - uuid
    **/
    /**
     * Name: Forum member signup settings: which option shows first. Evid: 47.
     * Event description: When first option is changed.
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * option - Type: string. Desc: New member signup/Existing member login
     *
     * uuid - Type: guid. Desc: uuid
     * @param {forumMemberSignupSettingsWhichOptionShowsFirstParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.forumMemberSignupSettingsWhichOptionShowsFirst = function (params) {
        return this.bi.log(__assign({ evid: 47 }, params));
    };
    /**
    * @typedef {Object} forumFeedOptionsParams
    * @property {string} activity_type - views counter/filtered hashtags/social sharing options
    * @property {string} editor_view_mode - desktop/mobile
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} type - on/off
    * @property {GUID} uuid - uuid
    **/
    /**
     * Name: Forum feed options. Evid: 44.
     * Event description: When user sets which information can be seen on forum feed.
    
     * activity_type - Type: string. Desc: views counter/filtered hashtags/social sharing options
     *
     * editor_view_mode - Type: string. Desc: desktop/mobile
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * type - Type: string. Desc: on/off
     *
     * uuid - Type: guid. Desc: uuid
     * @param {forumFeedOptionsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.forumFeedOptions = function (params) {
        return this.bi.log(__assign({ evid: 44 }, params));
    };
    /**
    * @typedef {Object} manageForumSettingsToggleParams
    * @property {string} currentValue - current value of the toggle
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} targetValue - target value of the toggle
    **/
    /**
     * Name: Manage forum - settings - toggle. Evid: 30.
     * Event description: When the user clicks on the toggle between start with categories (Yes/no).
    
     * currentValue - Type: string. Desc: current value of the toggle
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * targetValue - Type: string. Desc: target value of the toggle
     * @param {manageForumSettingsToggleParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.manageForumSettingsToggle = function (params) {
        return this.bi.log(__assign({ evid: 30 }, params));
    };
    /**
    * @typedef {Object} businessManagerFinishedLoadingParams
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - msid
    * @property {string} origin - "sidebar", "editor_gfpp", "editor_app_settings", "adi_manage", "adi_pages_panel", "dashboard widget", "manage tab"
    **/
    /**
     * Name: business manager finished loading. Evid: 70.
     * Event description: Event triggered when BM finishes loading for a user.
    
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: "sidebar", "editor_gfpp", "editor_app_settings", "adi_manage", "adi_pages_panel", "dashboard widget", "manage tab"
     * @param {businessManagerFinishedLoadingParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.businessManagerFinishedLoading = function (params) {
        return this.bi.log(__assign({ evid: 70 }, params));
    };
    /**
    * @typedef {Object} actionButtonCategoryCancelEditingParams
    * @property {string} application_type - OneApp / Web
    * @property {string} category_access - everyone / members_only / selected_members
    * @property {GUID} instance_id - category instance id
    * @property {boolean} is_changed - if the user has changed anything
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} biToken - site msid
    * @property {string} posts_format - discussion / question / all
    * @property {string} prev_category_access - Previous value (before save): everyone / members_only / selected_members
    * @property {GUID} visitor_id - visitor id
    **/
    /**
     * Name: action button -> category cancel editing. Evid: 577.
     * Event description: Event triggered after you cancel category editing.
    
     * application_type - Type: string. Desc: OneApp / Web
     *
     * category_access - Type: string. Desc: everyone / members_only / selected_members
     *
     * instance_id - Type: guid. Desc: category instance id
     *
     * is_changed - Type: bool. Desc: if the user has changed anything
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * biToken - Type: guid. Desc: site msid
     *
     * posts_format - Type: string. Desc: discussion / question / all
     *
     * prev_category_access - Type: string. Desc: Previous value (before save): everyone / members_only / selected_members
     *
     * visitor_id - Type: guid. Desc: visitor id
     * @param {actionButtonCategoryCancelEditingParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.actionButtonCategoryCancelEditing = function (params) {
        return this.bi.log(__assign({ evid: 577 }, params));
    };
    /**
    * @typedef {Object} oneAppForumDisplaySettingsParams
    * @property {string} application_id - OneApp / Web
    * @property {string} applicationType - OneApp / Web
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {GUID} site_member_id - site_member_id
    * @property {string} type - list of posts / list of categories
    * @property {GUID} ownerId - owner id
    * @property {GUID} uuid - uuid
    **/
    /**
     * Name: OneApp -> forum display settings. Evid: 54.
     * Event description: When the user selects forum display: list of posts / list of categories.
    
     * application_id - Type: string. Desc: OneApp / Web
     *
     * applicationType - Type: string. Desc: OneApp / Web
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * site_member_id - Type: guid. Desc: site_member_id
     *
     * type - Type: string. Desc: list of posts / list of categories
     *
     * ownerId - Type: guid. Desc: owner id
     *
     * uuid - Type: guid. Desc: uuid
     * @param {oneAppForumDisplaySettingsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.oneAppForumDisplaySettings = function (params) {
        return this.bi.log(__assign({ evid: 54 }, params));
    };
    /**
    * @typedef {Object} paginationClickParams
    * @property {string} button_type - button_type
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} origin - feed_page, post_page, search, business_manager
    * @property {string} page_destination - (1,2...,previous,next) - string
    * @property {GUID} site_member_id - site member id
    **/
    /**
     * Name: pagination click. Evid: 519.
     * Event description: Event triggered when you click on pagination (move between pages - numbers, back, forward).
    
     * button_type - Type: string. Desc: button_type
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: feed_page, post_page, search, business_manager
     *
     * page_destination - Type: string. Desc: (1,2...,previous,next) - string
     *
     * site_member_id - Type: guid. Desc: site member id
     * @param {paginationClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.paginationClick = function (params) {
        return this.bi.log(__assign({ evid: 519 }, params));
    };
    /**
    * @typedef {Object} forumLayoutHeaderHeightParams
    * @property {string} editor_view_mode - mobile / desktop
    * @property {number} height - chosen height
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} origin - main page/posts page
    * @property {GUID} uuid - uuid
    **/
    /**
     * Name: Forum layout: header height. Evid: 43.
     * Event description: When the user changes header height.
    
     * editor_view_mode - Type: string. Desc: mobile / desktop
     *
     * height - Type: numeric. Desc: chosen height
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: main page/posts page
     *
     * uuid - Type: guid. Desc: uuid
     * @param {forumLayoutHeaderHeightParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.forumLayoutHeaderHeight = function (params) {
        return this.bi.log(__assign({ evid: 43 }, params));
    };
    /**
    * @typedef {Object} forumSettingsAllowSocialLoginParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} socialNetwork - Google+/Facebook
    * @property {string} type - on/off
    * @property {GUID} uuid - uuid
    **/
    /**
     * Name: Forum settings: allow social login. Evid: 49.
     * Event description: When user switch toggle next to social page name.
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * socialNetwork - Type: string. Desc: Google+/Facebook
     *
     * type - Type: string. Desc: on/off
     *
     * uuid - Type: guid. Desc: uuid
     * @param {forumSettingsAllowSocialLoginParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.forumSettingsAllowSocialLogin = function (params) {
        return this.bi.log(__assign({ evid: 49 }, params));
    };
    /**
    * @typedef {Object} manageForumCreateNewCategoryParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} type - category/subcategory
    **/
    /**
     * Name: Manage forum - create new category. Evid: 29.
     * Event description: When the user clicks to create new category in the manage forum page.
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * type - Type: string. Desc: category/subcategory
     * @param {manageForumCreateNewCategoryParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.manageForumCreateNewCategory = function (params) {
        return this.bi.log(__assign({ evid: 29 }, params));
    };
    /**
    * @typedef {Object} postClickToCommentParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} post_id - post id
    * @property {string} role - owner/member
    * @property {GUID} site_member_id - site_member_id
    **/
    /**
     * Name: Post - click to comment. Evid: 15.
     * Event description: When the user clicks on "comment" to add comment.
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * post_id - Type: string. Desc: post id
     *
     * role - Type: string. Desc: owner/member
     *
     * site_member_id - Type: guid. Desc: site_member_id
     * @param {postClickToCommentParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.postClickToComment = function (params) {
        return this.bi.log(__assign({ evid: 15 }, params));
    };
    /**
    * @typedef {Object} fileUploadedParams
    * @property {string} application_type - Web / OneApp
    * @property {string} file_ext - File extension
    * @property {string} file_id - The file identifier (null if not successful)
    * @property {number} file_size - The size of the file being uploaded (in bytes)
    * @property {GUID} instance_id - instance id
    * @property {string} mime_type - File type
    * @property {GUID} biToken - metasite id
    * @property {string} origin - live / business_manager
    * @property {boolean} success - 0 - upload failed / 1 - upload successful
    * @property {string} type - post, comment, reply, general
    * @property {GUID} uuid - uuid
    **/
    /**
     * Name: file uploaded. Evid: 571.
     * Event description: Event triggered when a person tries to upload a file to a forum post, comment or reply (Only files within the size limit trigger the event).
    
     * application_type - Type: string. Desc: Web / OneApp
     *
     * file_ext - Type: string. Desc: File extension
     *
     * file_id - Type: string. Desc: The file identifier (null if not successful)
     *
     * file_size - Type: numeric. Desc: The size of the file being uploaded (in bytes)
     *
     * instance_id - Type: guid. Desc: instance id
     *
     * mime_type - Type: string. Desc: File type
     *
     * biToken - Type: guid. Desc: metasite id
     *
     * origin - Type: string. Desc: live / business_manager
     *
     * success - Type: bool. Desc: 0 - upload failed / 1 - upload successful
     *
     * type - Type: string. Desc: post, comment, reply, general
     *
     * uuid - Type: guid. Desc: uuid
     * @param {fileUploadedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.fileUploaded = function (params) {
        return this.bi.log(__assign({ evid: 571 }, params));
    };
    /**
    * @typedef {Object} adiForumSettingsGeneralDisplayOptionsChangedParams
    * @property {GUID} instance_id - instance id
    * @property {GUID} biToken - msid
    * @property {string} options - CSV list of all selected options: e.g.: view_counter, hashtags, social_sharing_icons, badges
    * @property {string} origin - ADI / Editor
    * @property {GUID} site_member_id - site_member_id
    * @property {GUID} uuid - user id
    **/
    /**
     * Name: Forum settings: general display options changed. Evid: 74.
     * Event description: Event is triggered when a user selects or deselect one or more options in the “general display options”.
    
     * instance_id - Type: guid. Desc: instance id
     *
     * biToken - Type: guid. Desc: msid
     *
     * options - Type: string. Desc: CSV list of all selected options: e.g.: view_counter, hashtags, social_sharing_icons, badges
     *
     * origin - Type: string. Desc: ADI / Editor
     *
     * site_member_id - Type: guid. Desc: site_member_id
     *
     * uuid - Type: guid. Desc: user id
     * @param {adiForumSettingsGeneralDisplayOptionsChangedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.adiForumSettingsGeneralDisplayOptionsChanged = function (params) {
        return this.bi.log(__assign({ evid: 74 }, params));
    };
    /**
    * @typedef {Object} manageForumLoadedParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    **/
    /**
     * Name: Manage Forum - loaded. Evid: 27.
     * Event description: When manage forum page is loaded in OneApp.
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     * @param {manageForumLoadedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.manageForumLoaded = function (params) {
        return this.bi.log(__assign({ evid: 27 }, params));
    };
    /**
    * @typedef {Object} categoriesMakeCategoryToSubcategoryOrViceVersaParams
    * @property {string} applicationType - OneApp / Web
    * @property {string} category_access - everyone / members_only / selected_members
    * @property {string} category_id - category id
    * @property {GUID} instance_id - null
    * @property {string} method - three_dot / drag
    * @property {GUID} biToken - null
    * @property {string} origin - live_site /editor/manage ("manage" is relevant for OneApp)
    * @property {string} parent_category_access - everyone / members_only / selected_members, Null if regular category
    * @property {string} parent_category_id - Parent category id. Null if regular category
    * @property {string} prev_category_access - Previous value (before save): everyone / members_only / selected_members
    * @property {GUID} site_member_id - site_member_id
    * @property {GUID} subcategory_id - subcategory id
    * @property {string} type - type before change: category/subcategory
    * @property {string} type_chosen - category/subcategory
    * @property {GUID} uuid - owner uuid
    **/
    /**
     * Name: Categories - make category to subcategory or vice versa. Evid: 55.
     * Event description: When the user makes category to subcategory or vice versa.
    
     * applicationType - Type: string. Desc: OneApp / Web
     *
     * category_access - Type: string. Desc: everyone / members_only / selected_members
     *
     * category_id - Type: string. Desc: category id
     *
     * instance_id - Type: guid.
     *
     * method - Type: string. Desc: three_dot / drag
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: live_site /editor/manage ("manage" is relevant for OneApp)
     *
     * parent_category_access - Type: string. Desc: everyone / members_only / selected_members, Null if regular category
     *
     * parent_category_id - Type: string. Desc: Parent category id. Null if regular category
     *
     * prev_category_access - Type: string. Desc: Previous value (before save): everyone / members_only / selected_members
     *
     * site_member_id - Type: guid. Desc: site_member_id
     *
     * subcategory_id - Type: guid. Desc: subcategory id
     *
     * type - Type: string. Desc: type before change: category/subcategory
     *
     * type_chosen - Type: string. Desc: category/subcategory
     *
     * uuid - Type: guid. Desc: owner uuid
     * @param {categoriesMakeCategoryToSubcategoryOrViceVersaParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.categoriesMakeCategoryToSubcategoryOrViceVersa = function (params) {
        return this.bi.log(__assign({ evid: 55 }, params));
    };
    /**
    * @typedef {Object} forumSettingsPoliciesParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} policyType - Terms of use page / Privacy policy / Code of conduct page
    * @property {string} type - on/off
    * @property {GUID} uuid - uuid
    **/
    /**
     * Name: Forum settings: policies. Evid: 51.
     * Event description: When toggle is switched on/off.
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * policyType - Type: string. Desc: Terms of use page / Privacy policy / Code of conduct page
     *
     * type - Type: string. Desc: on/off
     *
     * uuid - Type: guid. Desc: uuid
     * @param {forumSettingsPoliciesParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.forumSettingsPolicies = function (params) {
        return this.bi.log(__assign({ evid: 51 }, params));
    };
    /**
    * @typedef {Object} forumSettingsFontSizeParams
    * @property {string} fontSize - font size
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} place - post title / post description / header title / header description
    * @property {GUID} uuid - uuid
    **/
    /**
     * Name: Forum settings: font size. Evid: 53.
     * Event description: When font size is selected.
    
     * fontSize - Type: string. Desc: font size
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * place - Type: string. Desc: post title / post description / header title / header description
     *
     * uuid - Type: guid. Desc: uuid
     * @param {forumSettingsFontSizeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.forumSettingsFontSize = function (params) {
        return this.bi.log(__assign({ evid: 53 }, params));
    };
    /**
    * @typedef {Object} forumSettingsCustomizePostToolbarParams
    * @property {string} feature - image/gallery/video/divider/HTML/emoji
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} type - on/off
    * @property {GUID} uuid - uuid
    **/
    /**
     * Name: Forum settings: customize post toolbar. Evid: 565.
     * Event description: Event triggered after switching toggl.
    
     * feature - Type: string. Desc: image/gallery/video/divider/HTML/emoji
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * type - Type: string. Desc: on/off
     *
     * uuid - Type: guid. Desc: uuid
     * @param {forumSettingsCustomizePostToolbarParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.forumSettingsCustomizePostToolbar = function (params) {
        return this.bi.log(__assign({ evid: 565 }, params));
    };
    /**
    * @typedef {Object} forumPageViewParams
    * @property {string} application_id - Unused
    * @property {string} applicationType - OneApp / Web
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    **/
    /**
     * Name: Forum page view. Evid: 56.
     * Event description: When forum view is loaded in web or OneApp.
    
     * application_id - Type: string. Desc: Unused
     *
     * applicationType - Type: string. Desc: OneApp / Web
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     * @param {forumPageViewParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.forumPageView = function (params) {
        return this.bi.log(__assign({ evid: 56 }, params));
    };
    /**
    * @typedef {Object} postClickOnCommentsParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} post_id - post id
    **/
    /**
     * Name: Post - click on comments. Evid: 18.
     * Event description: When the user clicks on comments to view all the comments.
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * post_id - Type: string. Desc: post id
     * @param {postClickOnCommentsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.postClickOnComments = function (params) {
        return this.bi.log(__assign({ evid: 18 }, params));
    };
    /**
    * @typedef {Object} newPostClickNextParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {GUID} site_member_id - site_member_id
    **/
    /**
     * Name: New post - click next. Evid: 35.
     * Event description: When the user clicks next in the new post page in order to choose category.
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * site_member_id - Type: guid. Desc: site_member_id
     * @param {newPostClickNextParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.newPostClickNext = function (params) {
        return this.bi.log(__assign({ evid: 35 }, params));
    };
    /**
    * @typedef {Object} postClickOnReactionsParams
    * @property {string} comment_id - comment id
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} post_id - post id
    * @property {GUID} site_member_id - site_member_id
    **/
    /**
     * Name: Post - click on reactions. Evid: 17.
     * Event description: Click on reactions in a post to view reactions list.
    
     * comment_id - Type: string. Desc: comment id
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * post_id - Type: string. Desc: post id
     *
     * site_member_id - Type: guid. Desc: site_member_id
     * @param {postClickOnReactionsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.postClickOnReactions = function (params) {
        return this.bi.log(__assign({ evid: 17 }, params));
    };
    /**
    * @typedef {Object} clickOnPostParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} origin - feed_page, post_edit_page, categories_page, search_results, create_post, post_page, post_list_item_recent_activity, bm_toast_cta, bm_post_list_title, bm_post_list_cta, widget
    * @property {string} post_id - post_id guid
    * @property {string} post_name - post_slug
    * @property {string} post_slug - post_slug
    * @property {string} search_text - string value when ORIGIN = 'auto_suggest' fires. Otherwise value NULL.
    * @property {GUID} site_member_id - site_member_id
    * @property {string} type - post, comment, recent_activity
    **/
    /**
     * Name: click on post. Evid: 516.
     * Event description: Event triggered when clicking on a post.
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: feed_page, post_edit_page, categories_page, search_results, create_post, post_page, post_list_item_recent_activity, bm_toast_cta, bm_post_list_title, bm_post_list_cta, widget
     *
     * post_id - Type: string. Desc: post_id guid
     *
     * post_name - Type: string. Desc: post_slug
     *
     * post_slug - Type: string. Desc: post_slug
     *
     * search_text - Type: string. Desc: string value when ORIGIN = 'auto_suggest' fires. Otherwise value NULL.
     *
     * site_member_id - Type: guid. Desc: site_member_id
     *
     * type - Type: string. Desc: post, comment, recent_activity
     * @param {clickOnPostParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickOnPost = function (params) {
        return this.bi.log(__assign({ evid: 516 }, params));
    };
    /**
    * @typedef {Object} addPhotoParams
    * @property {string} comment_id - comment id
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} origin - (post,comment,reply)
    * @property {string} post_id - post id
    * @property {GUID} site_member_id - site_member_id
    **/
    /**
     * Name: Add photo or video. Evid: 23.
     * Event description: When the user clicks to add photo.
    
     * comment_id - Type: string. Desc: comment id
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: (post,comment,reply)
     *
     * post_id - Type: string. Desc: post id
     *
     * site_member_id - Type: guid. Desc: site_member_id
     * @param {addPhotoParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.addPhoto = function (params) {
        return this.bi.log(__assign({ evid: 23 }, params));
    };
    /**
    * @typedef {Object} mentionsMentionsSuggestionsListMemberClickedParams
    * @property {string} comment_id - deprecated
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} post_id - deprecated
    **/
    /**
     * Name: mention suggestions member selected. Evid: 21.
     * Event description: When a user clicks one user from the mentioned list.
    
     * comment_id - Type: string. Desc: deprecated
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * post_id - Type: string. Desc: deprecated
     * @param {mentionsMentionsSuggestionsListMemberClickedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.mentionsMentionsSuggestionsListMemberClicked = function (params) {
        return this.bi.log(__assign({ evid: 21 }, params));
    };
    /**
    * @typedef {Object} postCommentClickOnReplyParams
    * @property {string} comment_id - comment id
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} post_id - post id
    **/
    /**
     * Name: Post - comment - click on reply. Evid: 19.
     * Event description: When the user clicks on reply to comment.
    
     * comment_id - Type: string. Desc: comment id
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * post_id - Type: string. Desc: post id
     * @param {postCommentClickOnReplyParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.postCommentClickOnReply = function (params) {
        return this.bi.log(__assign({ evid: 19 }, params));
    };
    /**
    * @typedef {Object} forumDesignCornerRadiusParams
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - msid
    * @property {string} section - forum background / button style
    * @property {GUID} uuid - uuid
    * @property {string} value - chosen corner radius
    **/
    /**
     * Name: Forum design: corner radius. Evid: 87.
     * Event description: Triggers when user changes corner radius slider.
    
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid. Desc: msid
     *
     * section - Type: string. Desc: forum background / button style
     *
     * uuid - Type: guid. Desc: uuid
     *
     * value - Type: string. Desc: chosen corner radius
     * @param {forumDesignCornerRadiusParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.forumDesignCornerRadius = function (params) {
        return this.bi.log(__assign({ evid: 87 }, params));
    };
    /**
    * @typedef {Object} mentionsMentionsSuggestionsListOpenedParams
    * @property {string} comment_id - deprecated
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} post_id - deprecated
    * @property {string} role - deprecated
    * @property {string} type - comment/ reply/post
    **/
    /**
     * Name: mentions suggestions list opened. Evid: 20.
     * Event description: When a user added '@' from top bar or from keyboard and the suggestions list opened.
    
     * comment_id - Type: string. Desc: deprecated
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * post_id - Type: string. Desc: deprecated
     *
     * role - Type: string. Desc: deprecated
     *
     * type - Type: string. Desc: comment/ reply/post
     * @param {mentionsMentionsSuggestionsListOpenedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.mentionsMentionsSuggestionsListOpened = function (params) {
        return this.bi.log(__assign({ evid: 20 }, params));
    };
    /**
    * @typedef {Object} postThreeDotsActionButtonParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} post_id - post id
    * @property {string} role - (owner/member)
    * @property {string} value - value of the button chosen
    **/
    /**
     * Name: Post - three dots - action button. Evid: 13.
     * Event description: When a user chooses an action button from the menu opened from clicking on the three dots on a post.
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * post_id - Type: string. Desc: post id
     *
     * role - Type: string. Desc: (owner/member)
     *
     * value - Type: string. Desc: value of the button chosen
     * @param {postThreeDotsActionButtonParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.postThreeDotsActionButton = function (params) {
        return this.bi.log(__assign({ evid: 13 }, params));
    };
    return Logger;
}());
export { Logger };
export default init;
export function getLoggerConf() {
    return {
        src: 69,
        endpoint: 'forums-users'
    };
}
//# sourceMappingURL=index.js.map